import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ProducerContext } from './AccountDropDownValuesContext';
import metadata from './AccountDropDownValues.metadata.json5';
import styles from './AccountDropDownValues.module.scss';

const AccountDropDownValues = (props) => {
    const { hideMyWork, onValueChange, getAccountName, getInvoiceDropValue, pageBilling, pageMakeAPayment} = props;
    const [availableProducerCode, setProducerCodeList] = useState([]);

    const { producerCodeList, producerCode, setProducerCode, multiInvoiceDropDown,
        setMultiInvoiceDropDown } = useContext(ProducerContext);

    const getSelectedProducerCode = useCallback(

        (codeList) => {
            if( props.removeSelected && producerCodeList.length > 1){
                return null;
            }

            if (props.accNumCreditCard !== undefined && (props.message === 'PaymentSuccessful' || props?.pageMakeAPayment==="MakePayment")) {
                return props.accNumCreditCard;
            }

            if (props?.history?.location?.state?.page === 'LandingPage' || typeof (props?.history?.location?.state?.page) === "undefined") {
                if (!_.isEmpty(codeList) && producerCodeList.length !== 0) {
                    return _.some(codeList, { code: producerCode }) ? producerCode : producerCodeList[0].code;
                }
            }

            return null;
        },
        [producerCode, producerCodeList, props.accNumCreditCard, props?.history?.location?.state?.page, props.message, props?.pageMakeAPayment, props.removeSelected]
    );

    useEffect(()=>{
        if(props.removeSelected && producerCode!==null){
            setProducerCode('')

            if(props?.pageMakeAPayment==="MakePayment"){
                setMultiInvoiceDropDown(undefined)
            }

            if(multiInvoiceDropDown !== "" && pageMakeAPayment === "MakePayment" ){
                getInvoiceDropValue(multiInvoiceDropDown)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
        let Lengths;

        if (hideMyWork && !_.isEmpty(producerCodeList)) {
            const codeList = _.filter(producerCodeList, (list) => list.code !== 'myWork');
            const code = getSelectedProducerCode(codeList);

            if (onValueChange) {
                onValueChange(code);
            }

            if (getAccountName) {
                getAccountName(producerCodeList.filter((item) => item.code === code));
            }

            if (getInvoiceDropValue && multiInvoiceDropDown !== undefined && multiInvoiceDropDown !== "") {
                getInvoiceDropValue(multiInvoiceDropDown);
            }

            if (pageBilling === "Billing") {
                getInvoiceDropValue(multiInvoiceDropDown);
            }

            if (multiInvoiceDropDown === undefined && props?.pageMakeAPayment === "MakePayment") {
                getInvoiceDropValue(multiInvoiceDropDown);
            }

            setProducerCodeList(codeList);
            Lengths = codeList.filter((item) => item.code!=="all").map((i) => i.name.length)
        } else {
            Lengths = producerCodeList.filter((item) => item.code!=="all" && item.code !== 'myWork').map((i) => i.name.length)
            setProducerCodeList(producerCodeList);
        }

        const MaxValue = Math.max(...Lengths)

        window.document.documentElement.style.setProperty('--gw-select-box-style-width',`${MaxValue*0.6}rem`);

    }, [getAccountName, getInvoiceDropValue, getSelectedProducerCode, hideMyWork, multiInvoiceDropDown, onValueChange, producerCodeList, pageBilling, props?.pageMakeAPayment]);

    const handleValueChange = useCallback(
        (code) => {
            if (onValueChange) {
                onValueChange(code);
               // getInvoiceDropValue(undefined)
                setMultiInvoiceDropDown(undefined)
            }

            setProducerCode(code);

            if (getAccountName) {
                getAccountName(producerCodeList.filter((item) => item.code === code));

            }
            },
        [getAccountName, onValueChange, producerCodeList, setMultiInvoiceDropDown, setProducerCode]
    );




    const overrideProps = {
        availableProducerCode: {
            availableValues: availableProducerCode,
            value: getSelectedProducerCode(availableProducerCode),
            visible: producerCodeList.length > 1
        },
        accountDropdown:{
            visible: producerCodeList.length > 1
        },

        '@field': {
            claimListData: {
                claimListData:producerCode
            }
        },

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleValueChange
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

AccountDropDownValues.propTypes = {
    hideMyWork: PropTypes.bool,
    onValueChange: PropTypes.func
};
AccountDropDownValues.defaultProps = {
    hideMyWork: true,
    onValueChange: undefined
};

export default AccountDropDownValues;
